@if (params()?.value) {
  <div [matTooltip]="tooltip()" [matTooltipClass]="'warning-tooltip'" [matTooltipDisabled]="!params()?.value" matTooltipPosition="above">
    <mat-icon class="table-icon-content" svgIcon="event_alarm" color="warn" />
  </div>
}
